module.exports = __webpack_public_path__ + "img/GreekTechTrireme3_ua.56016804.webp";